import React from 'react';
import ServicePageTemplate from '@/components/ServicePageTemplate';

const ClonagemPage: React.FC = () => {
  return <ServicePageTemplate serviceSlug="clonagem" />;
};

export default ClonagemPage;